export default [
    {
      path: '/newUserOrder',
      meta:{
        title: '百果园'
      },
      component: (resolve) => require(['@/pages/newUserOrder/index'], resolve)
    }
  ]